export type Category = {
  slug: string;
  name: string;
  desc: string;
  icon: string;
};

export const categories: Category[] = [
  {
    slug: "workflow",
    name: "数字工作",
    desc: "时间管理、效率工具与工作方法，帮你更从容地应对日常。",
    icon: "ri-computer-line",
  },
  {
    slug: "read",
    name: "阅读新知",
    desc: "读书方法、知识管理与思维方式，让输入真正沉淀下来。",
    icon: "ri-book-open-line",
  },
  {
    slug: "life",
    name: "生活灵感",
    desc: "生活方式、情绪自愈与日常美学，认真对待每一天。",
    icon: "ri-plant-line",
  },
  {
    slug: "grow",
    name: "认知成长",
    desc: "复盘、边界与人际经营，在向内探索中稳步成长。",
    icon: "ri-seedling-line",
  },
];

export type EditorMember = {
  name: string;
  role: string;
  intro: string;
  avatar: string;
  color: string;
};

export const editors: EditorMember[] = [
  {
    name: "周屿",
    role: "效率栏目主编",
    intro: "专注时间管理与工作方法研究，相信好的节奏胜过蛮力。",
    avatar: "周",
    color: "bg-primary-500",
  },
  {
    name: "顾言",
    role: "阅读栏目编辑",
    intro: "一年精读五十本书，致力于把阅读变成可复制的日常习惯。",
    avatar: "顾",
    color: "bg-secondary-500",
  },
  {
    name: "林简",
    role: "生活方式作者",
    intro: "相信生活需要留白，从整理、独处与休息里重获力量。",
    avatar: "林",
    color: "bg-accent-500",
  },
  {
    name: "陈默",
    role: "成长专栏主笔",
    intro: "关注自我管理与认知升级，主张用复盘把经历变成能力。",
    avatar: "陈",
    color: "bg-primary-600",
  },
];

export type FaqItem = { q: string; a: string };

export const faqs: FaqItem[] = [
  {
    q: "看料的精选内容是怎么产生的？",
    a: "看料的内容由编辑团队结合用户关注的热门主题与多平台趋势，人工筛选、甄别后整理成文。每一篇「精选好料」都经过选题、写作与事实核对，力求观点清晰、来源可靠、读完有收获。",
  },
  {
    q: "「热门推荐」和「编辑精选」有什么区别？",
    a: "热门推荐侧重反映当下大家在关注什么、讨论什么，更新快、视角广；编辑精选则是由主编从信息密度、启发性和实用性角度优中选优，代表我们最有把握「值得一读」的那批内容。",
  },
  {
    q: "看料多久更新一次？",
    a: "看料的编辑团队每日筛选并更新内容，热门推荐会随当日动态滚动刷新，编辑精选榜单则定期复盘重排，确保你每次打开都能看到新鲜、值得看的好料。",
  },
  {
    q: "如何向看料投稿或推荐内容？",
    a: "如果你有值得分享的内容或选题，欢迎通过网站「联系我们」的邮箱与我们交流。收到后会由对应栏目编辑评估，采纳后会与你确认署名与发布细节。",
  },
  {
    q: "看料的内容是否收费？",
    a: "目前看料网站上的全部精选与推荐文章均可免费阅读，我们不向读者收取任何订阅费用。若未来推出深度专题或会员内容，会提前明确说明。",
  },
  {
    q: "可以用手机方便地浏览吗？",
    a: "可以。看料采用响应式设计，在电脑、平板与手机上都能获得清晰舒适的阅读体验，移动端菜单、榜单与文章页都已针对小屏做了优化。",
  },
];

export type Testimonial = {
  quote: string;
  name: string;
  meta: string;
};

export const testimonials: Testimonial[] = [
  {
    quote: "早上通勤刷十分钟看料，就能把当天值得关注的选题一次看完，帮我省下了大量来回切换的时间。",
    name: "阿澈",
    meta: "自由设计师",
  },
  {
    quote: "编辑选品很有章法，不会有那种为了凑量硬写的文章。好几篇讲时间管理的内容，读完真的用起来了。",
    name: "Joan",
    meta: "产品运营",
  },
  {
    quote: "把「每日好料」设成了固定栏目后，反而不焦虑信息过载了——重要的会由看料帮我看好。",
    name: "老白",
    meta: "终身学习者",
  },
];

export const stats: { value: string; label: string }[] = [
  { value: "2000+", label: "累计甄选好料" },
  { value: "48", label: "每周精选更新" },
  { value: "12h", label: "每日内容核实" },
  { value: "9.2", label: "读者内容评分" },
];